import { BaseHTMLAttributes, FC, ReactNode, useEffect, useState } from "react"
import {
  StyledSummaryCol,
  StyledSummaryItem,
  StyledSummaryItemBody,
} from "./StyledSummary"
import { colors } from "../../../styles/utils/vars"

const SummaryItem: FC<
  BaseHTMLAttributes<HTMLLIElement> & {
    title?: string
    value?: string | number | ReactNode
    type?: "red"
  }
> = ({ title, value, type, children, ...props }) => {
  const [color, setColor] = useState<string | null>(null)

  useEffect(() => {
    switch (type) {
      case "red": {
        setColor(colors.red)
        break
      }
      default: {
        setColor(null)
        break
      }
    }
  }, [type])

  return (
    <StyledSummaryItem {...props} color={color !== null ? color : props.color}>
      {title && <StyledSummaryCol>{title}</StyledSummaryCol>}
      {value && <StyledSummaryCol>{value}</StyledSummaryCol>}
      {children && <StyledSummaryItemBody>{children}</StyledSummaryItemBody>}
    </StyledSummaryItem>
  )
}

export { SummaryItem }
